"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4853" id="nationwide-real-estate-solutions" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_inspection_cta.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/80 to-background/95" aria-hidden="true" />

      {}
      <div className="absolute top-6 left-6 w-8 h-8 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 left-0 w-full h-px bg-primary" />
        <div className="absolute top-0 left-0 h-full w-px bg-primary" />
      </div>
      <div className="absolute top-6 right-6 w-8 h-8 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 right-0 w-full h-px bg-primary" />
        <div className="absolute top-0 right-0 h-full w-px bg-primary" />
      </div>
      <div className="absolute bottom-6 left-6 w-8 h-8 pointer-events-none" aria-hidden="true">
        <div className="absolute bottom-0 left-0 w-full h-px bg-primary" />
        <div className="absolute bottom-0 left-0 h-full w-px bg-primary" />
      </div>
      <div className="absolute bottom-6 right-6 w-8 h-8 pointer-events-none" aria-hidden="true">
        <div className="absolute bottom-0 right-0 w-full h-px bg-primary" />
        <div className="absolute bottom-0 right-0 h-full w-px bg-primary" />
      </div>

      {}
      <div className="hidden md:block absolute left-12 top-1/2 -translate-y-1/2 pointer-events-none" aria-hidden="true">
        <div className="flex flex-col gap-6">
          {[0, 1, 2, 3, 4].map(i => <div key={i} data-index={i} className="flex items-center gap-2">
              <div className="w-3 h-px bg-foreground/30" />
              <span className="font-mono text-[10px] text-foreground/40">
                {String(i * 25).padStart(3, "0")}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="hidden md:block absolute right-12 top-1/2 -translate-y-1/2 pointer-events-none" aria-hidden="true">
        <div className="flex flex-col gap-6">
          {[0, 1, 2, 3, 4].map(i => <div key={i} data-index={i} className="flex items-center gap-2">
              <span className="font-mono text-[10px] text-foreground/40">
                {String(i * 25).padStart(3, "0")}
              </span>
              <div className="w-3 h-px bg-foreground/30" />
            </div>)}
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto max-w-[960px] px-6 py-32 md:py-40 lg:py-[200px] flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex items-center gap-4 mb-10">
          <div className="h-px w-12 bg-primary" />
          <span className="font-mono text-xs tracking-[0.25em] text-foreground/80 uppercase">
            Schedule Service
          </span>
          <div className="h-px w-12 bg-primary" />
        </div>

        {}
        <h2 className="font-default font-light text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[112px] leading-[0.95] tracking-tight text-foreground mb-10">
          Professional care for your{" "}
          <span className="relative inline-block italic font-normal">
            property
            <span className="absolute left-0 -bottom-1 md:-bottom-2 h-[3px] md:h-1 w-full bg-primary" aria-hidden="true" />
          </span>
          .
        </h2>

        {}
        <p className="font-default text-base md:text-[19px] leading-relaxed text-foreground/70 max-w-[640px] mb-12">
          Luxury Construction LLC provides expert roofing and nationwide real estate solutions. Contact us today to discuss your project needs with our dedicated team.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center mb-8">
          <Button asChild size="lg" className="h-14 px-8 text-sm font-mono tracking-[0.2em] uppercase bg-primary text-primary-foreground hover:bg-primary/90 rounded-md">
            <Link to="/ContactUsPage">
              Get Free Quote
              <ArrowRight className="ml-1 size-4" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-sm font-mono tracking-[0.2em] uppercase bg-transparent border border-foreground/80 text-foreground hover:bg-foreground hover:text-background rounded-md">
            <Link to="tel:+16206400354">
              <Phone className="mr-1 size-4" />
              Call (620) 640-0354
            </Link>
          </Button>
        </div>

        {}
        <div className="flex items-center gap-3">
          <span className="relative flex size-2.5">
            <span className="absolute inline-flex h-full w-full rounded-md bg-primary opacity-75 animate-ping" />
            <span className="relative inline-flex size-2.5 rounded-md bg-primary" />
          </span>
          <span className="font-mono text-xs tracking-[0.25em] text-foreground/70 uppercase">
            Serving Southwest Kansas & Nationwide
          </span>
        </div>

        {}
        <div className="mt-16 flex items-center gap-4 font-mono text-[10px] tracking-[0.2em] text-foreground/40 uppercase">
          <span>EST 2023</span>
          <div className="h-px w-8 bg-foreground/30" />
          <span>LICENSED</span>
          <div className="h-px w-8 bg-foreground/30" />
          <span>LUXURY CONSTRUCTION</span>
        </div>
      </div>
    </section>;
}